import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ContactFaq from '../components/ContactFaq';
import ContactUs from '../components/ContactUs';

const Contact: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="main-wrapper">
            {/* Hero Banner Section */}
            <div className="section-hero-banar is-contact">
                <div className="padding-global">
                    <div className="container-large">
                        <div className="padding-section-medium">
                            <div className="hero-banner-component">
                                <div className="hero-banner-content-wrapper">
                                    <h2 className="heading-style-h2">{t('contactUs.pageTitle', '很乐意与您交流')}</h2>
                                    <div className="hero-banar-content">
                                        <Link to="/" className="home-link">
                                            {t('navbar.home', 'Home')}
                                        </Link>
                                        <div className="hero-banar-dot dot-color-yello"></div>
                                        <div className="hero-banar-text text-color-yello">
                                            {t('navbar.contact', 'Contact')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ Section */}
            <ContactFaq />

            {/* Contact Us Section */}
            <ContactUs />
        </div>
    );
};

export default Contact;
